<div class="container-fluid px-3">
  <div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
    <!-- Primera fila -->
    <div class="d-flex justify-content-between mb-3">
      <div>
        <label for="information" class="labelInformation">{{
          information
          }}</label>
      </div>
      <div>
        <button class="btn btn-secondary" (click)="goBack()">Back</button>
      </div>
    </div>
    <div class="row">
      <app-list-plan-devices [customerDataInput]="dataInput"></app-list-plan-devices>
    </div>
  </div>


</div>